module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"dd.MM.yyyy":"dd.MM.yyyy"}}')
  delete Component.options._Ctor
}
